import script from "./AproposView.vue?vue&type=script&setup=true&lang=js"
export * from "./AproposView.vue?vue&type=script&setup=true&lang=js"

import "./AproposView.vue?vue&type=style&index=0&id=54120c6d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54120c6d"]])

export default __exports__